var pageReact = {
    templateUrl : themeUrl + '/'
};